import { render } from "preact";
import { App } from "./app";
import "./styles/fonts.css";
import "./styles/global.css";
import "./styles/map.css";
import "./styles/components.css";
import "./styles/explore.css";
import "./styles/lab.css";

// index.html ships a static text block inside #app (real content for no-JS visitors and
// crawlers, and an honest first paint before the bundle runs). Clear it before mounting —
// render() would otherwise append alongside it.
const root = document.getElementById("app")!;
root.textContent = "";
render(<App />, root);
